import React from 'react';

const Shimmer = ({ className }) => {
  return (
    <div className={`animate-pulse bg-gray-200 rounded ${className}`}></div>
  );
};

// Predefined shimmer components for different use cases
export const MetricShimmer = () => (
  <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
    <div className="flex items-center justify-between">
      <div className="space-y-3">
        <Shimmer className="h-4 w-24" />
        <Shimmer className="h-8 w-16" />
      </div>
      <Shimmer className="h-12 w-12 rounded-full" />
    </div>
  </div>
);

export const ChartShimmer = () => (
  <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
    <Shimmer className="h-6 w-48 mb-4" />
    <div className="h-96">
      <Shimmer className="w-full h-full" />
    </div>
  </div>
);

export const TableRowShimmer = () => (
  <tr>
    <td className="px-6 py-4"><Shimmer className="h-4 w-24" /></td>
    <td className="px-6 py-4"><Shimmer className="h-4 w-16" /></td>
    <td className="px-6 py-4"><Shimmer className="h-4 w-16" /></td>
    <td className="px-6 py-4"><Shimmer className="h-4 w-16" /></td>
    <td className="px-6 py-4"><Shimmer className="h-4 w-16" /></td>
    <td className="px-6 py-4"><Shimmer className="h-4 w-16" /></td>
    <td className="px-6 py-4"><Shimmer className="h-4 w-16" /></td>
  </tr>
);

export const ActivityShimmer = () => (
  <div className="flex items-start space-x-3 p-3">
    <Shimmer className="h-5 w-5 rounded-full" />
    <div className="flex-1 space-y-2">
      <Shimmer className="h-4 w-full" />
      <Shimmer className="h-3 w-24" />
    </div>
  </div>
);

export default Shimmer; 